import { gql } from "@apollo/client";

export const GetDiscountCodePage = gql`
  query DicountCodePage($pagination: PaginationInput!) {
    dicountCodePage(pagination: $pagination) {
      totalRows
      items {
        code
        createdDate
        discountCodeType
        id
        isPercent
        isRestricted
        description
        name
        recurring
        startAt
        useLimit
        value
      }
    }
  }
`;

export const GetDiscountCodeOne = gql`
  query DiscountCodeOne($discountCodeOneId: String!) {
    discountCodeOne(id: $discountCodeOneId) {
      id
      createdDate
      updatedDate
      deletedDate
      name
      description
      startAt
      isPercent
      value
      code
      discountCodeType
      recurring
      useLimit
      isStaffOnly
      locations {
        name
        id
      }
      expiration {
        id
        unit
        expirationMode
        isExpired
        expiresAt
        value
      }
      isRestricted
    }
  }
`;

export const GetDiscountCodeAgreements = gql`
  query DiscountCodeAgreements(
    $discountCodeOneId: String!
    $isAgreement: Boolean!
  ) {
    discountCodeAgreementsOrProducts(
      id: $discountCodeOneId
      isAgreement: $isAgreement
    ) {
      id
      agreements {
        id
        name
      }
    }
  }
`;

export const GetDiscountCodeProducts = gql`
  query DiscountCodeProducts(
    $discountCodeOneId: String!
    $isAgreement: Boolean!
  ) {
    discountCodeAgreementsOrProducts(
      id: $discountCodeOneId
      isAgreement: $isAgreement
    ) {
      id
      products {
        name
        id
      }
    }
  }
`;

export const discountByCode = gql`
  query discountByCode($locationId: String!, $code: String!) {
    discountByCode(locationId: $locationId, code: $code) {
      name
      id
      value
      useLimit
      isPercent
      products {
        id
        name
        cost
      }
    }
  }
`;
